import owd from 'owd/owd';

export default class Header extends owd.Component {
	init() {
        this.$content = this.$element.find('[data-header-content]');
        this.$sections = this.dom.$body.find('[class*="section section--"], .footer');

        this.contentOffset = 0;
        this.sectionsOffsets = [];
        this.sectionsBgs = [];

		this.bind();
	}

    setOffsets() {
        this.contentOffset = this.$content.offset().top - this.$element.offset().top;

        this.$sections.each((i, obj) => {
            this.sectionsOffsets.push($(obj).offset().top);
            this.sectionsBgs.push($(obj).css('background-color'));
        })
    }

	bind() {
        this.on('load ajaxload resize', this.dom.$window, () => {
            this.setOffsets();
        })

        this.on('load ajaxload resize scroll', this.dom.$window, () => {
            let trigger = this.dom.$window[0].pageYOffset + this.contentOffset;
            let lastIndex = 0;
            let color;

            for (let i = 0; i < this.sectionsOffsets.length; i++) {
                if (trigger >= this.sectionsOffsets[i]) {
                    lastIndex = i;
                }

                color = this.sectionsBgs[lastIndex];
            }

            if (color != this.currentColor) {
                this.currentColor = color;

                if (!this.af) {
                    this.af = requestAnimationFrame(() => {
                        this.af = null;

                        this.$element.attr('data-bg-color', this.currentColor);
                    })
                }
            }
        })
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('header', {
	component: Header
});
